import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Container, Typography, Button } from '@mui/material';
// layouts
import LogoOnlyLayout from '../../layouts/LogoOnlyLayout';
// components
import Page from '../../components/Page';
// sections
import { VerifyCodeForm } from '../../sections/auth/verify-code';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function VerifyCode() {
  const { resendSignUp, verifyEmail, whoAmI } = useAuth();
  const [seconds, setSeconds] = useState(60);
  const sessionEmail = sessionStorage.getItem('verify-code');
  const { enqueueSnackbar } = useSnackbar();

  const handleResend = async () => {
    try {
      // await resendSignUp(sessionEmail);
      await verifyEmail(whoAmI?.email) 
      setSeconds(60);
      enqueueSnackbar('Code has been sent');
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  useEffect(() => {
    async function verifyEmailFunc() {
      try {
        await verifyEmail(whoAmI?.email)
        setSeconds(60);
        enqueueSnackbar('Code has been sent');
      } catch (error) {
        enqueueSnackbar(error.message, { variant: 'error' });
      }
    }
    
    if (whoAmI?.email) verifyEmailFunc()
  }, [whoAmI])

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(myInterval);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  return (
    <Page title="Verify Code">
      <LogoOnlyLayout fullPage />

      <Container>
        <ContentStyle sx={{ textAlign: 'center' }}>
          <Typography variant="h3" paragraph>
            Please check your email!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            We have emailed a 6-digit confirmation code to {sessionEmail}, please enter the code in the box below to verify your
            email.
          </Typography>

          <Box sx={{ mt: 5, mb: 3 }}>
            <VerifyCodeForm email={whoAmI?.email ?? sessionEmail} />
          </Box>

          <Typography variant="body2">
            Don’t have a code? &nbsp;
            {seconds ? (
              <Button disabled>{`${seconds}s to try again`}</Button>
            ) : (
              <Button onClick={handleResend}>Resend code</Button>
            )}
          </Typography>
        </ContentStyle>
      </Container>
    </Page>
  );
}
